import { render, staticRenderFns } from "./AnswersModal.vue?vue&type=template&id=ec9e22ce&scoped=true"
import script from "./AnswersModal.vue?vue&type=script&lang=ts"
export * from "./AnswersModal.vue?vue&type=script&lang=ts"
import style0 from "./AnswersModal.vue?vue&type=style&index=0&id=ec9e22ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9e22ce",
  null
  
)

export default component.exports